import { IHttpClient } from '@wix/yoshi-flow-editor';
import {
  WIX_NEW_STORES,
  WIX_EVENTS,
  WIX_BOOKINGS,
  WIX_RESTAURANTS_ORDERS,
  WIX_RESTAURANTS_ORDERS_NEW,
} from '@wix/app-definition-ids';

import { queryInstalledApps } from '../api/installed-apps.api';
import { LOYALTY_APP_DEFINITION_ID, REFERRALS_APP_DEFINITION_ID } from '../constants';

export interface AppInstallStatus {
  isLoyaltyAppInstalled: boolean;
  isReferralsAppInstalled: boolean;
  isStoresAppInstalled: boolean;
  isEventsAppInstalled: boolean;
  isBookingsAppInstalled: boolean;
  isOldRestaurantsAppInstalled: boolean;
  isNewRestaurantsAppInstalled: boolean;
}

const fetchInstalledAppsMap = async (httpClient: IHttpClient) => {
  const {
    data: { appsMap },
  } = await httpClient.request(
    queryInstalledApps({
      appDefIds: [
        WIX_NEW_STORES,
        WIX_EVENTS,
        WIX_BOOKINGS,
        WIX_RESTAURANTS_ORDERS,
        WIX_RESTAURANTS_ORDERS_NEW,
        LOYALTY_APP_DEFINITION_ID,
        REFERRALS_APP_DEFINITION_ID,
      ],
    }),
  );

  return appsMap;
};

export async function getAppInstallStatus(httpClient: IHttpClient): Promise<AppInstallStatus> {
  const appsMap = await fetchInstalledAppsMap(httpClient);

  return {
    isLoyaltyAppInstalled: appsMap[LOYALTY_APP_DEFINITION_ID],
    isReferralsAppInstalled: appsMap[REFERRALS_APP_DEFINITION_ID],
    isStoresAppInstalled: appsMap[WIX_NEW_STORES],
    isEventsAppInstalled: appsMap[WIX_EVENTS],
    isBookingsAppInstalled: appsMap[WIX_BOOKINGS],
    isOldRestaurantsAppInstalled: appsMap[WIX_RESTAURANTS_ORDERS],
    isNewRestaurantsAppInstalled: appsMap[WIX_RESTAURANTS_ORDERS_NEW],
  };
}
